<template>
  <div class="home mt-2">
    <a-row class="mobile-wrapper pl-2 pr-3">
      <a-col class="mobile-full-width" :span="15">
        <h2>
          Welcome back,
          <b class="text-bold">{{$auth.user().last_name}}</b>.
        </h2>
        <h5 style="line-height:20px" class="text-opacity">
          How are you doing this {{getTimeCategory()}}
          <br>Below are a list of Services to quickly get you started.
        </h5>
      </a-col>

      <a-col class="text-align-right" :span="9">
        <img class="jet-icon" style="width:50px" src="../../assets/img/jeticon.png">
      </a-col>
    </a-row>

    <!-- cards -->
    <a-row class="mobile-wrapper pl-2 pr-3">
      <a-col :span="8" class="mobile-full-width pr-3">
        <a-card>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="38.521"
            height="35"
            viewBox="0 0 123.521 127.56"
          >
            <defs>
              <linearGradient
                id="linear-gradient"
                x1="0.5"
                x2="0.5"
                y2="1"
                gradientUnits="objectBoundingBox"
              >
                <stop offset="0" stop-color="#3625be"></stop>
                <stop offset="1" stop-color="#1b135f"></stop>
              </linearGradient>
            </defs>
            <path
              id="iconmonstr-coin-10"
              d="M90.833,63.78c-18.6,0-33.687,14.281-33.687,31.89s15.086,31.89,33.687,31.89,33.687-14.281,33.687-31.89S109.434,63.78,90.833,63.78Zm2.807,45.039v2.8H90.833v-2.652a20.311,20.311,0,0,1-8.422-1.929l1.28-4.369c2.684.989,6.255,2.036,9.051,1.435,3.223-.691,3.885-3.832.32-5.342-2.611-1.153-10.606-2.137-10.606-8.621,0-3.62,2.92-6.867,8.377-7.574V79.725H93.64V82.43a27.519,27.519,0,0,1,6.855,1.116l-1.016,4.38a18.85,18.85,0,0,0-6.861-1.233c-4.177.229-4.548,3.657-1.628,5.092,4.806,2.137,11.072,3.721,11.072,9.424C102.068,105.769,98.289,108.2,93.64,108.819Zm9.118-54.1c6.356-1.185,12.139-3.327,16.148-6.362v3.465c0,2.652-2.167,5.076-5.654,7.058a46.022,46.022,0,0,0-10.494-4.162Zm-11.925-30.8c15.008,0,28.073-5.352,28.073-11.959S105.841,0,90.833,0,62.76,5.352,62.76,11.959,75.831,23.918,90.833,23.918Zm.522-10.678c-1.679-.478-6.816-.882-6.816-3.588,0-1.509,1.875-2.854,5.379-3.152V5.315h1.8V6.436a25.425,25.425,0,0,1,4.4.478l-.651,1.818A18.957,18.957,0,0,0,91.5,8.206l-.4.005c-2.706.106-2.925,1.525-1.056,2.121,3.071.9,7.114,1.552,7.114,3.933,0,1.9-2.437,2.913-5.429,3.168V18.6h-1.8V17.5a19.072,19.072,0,0,1-5.4-.808l.825-1.823a20.654,20.654,0,0,0,4.649.67l1.168-.074c2.072-.282,2.487-1.595.2-2.222ZM29.073,82.383c8.113,0,15.58-1.6,20.8-4.082A42.42,42.42,0,0,1,56.6,68.207c-2.532-5.544-14.255-9.742-27.528-9.742C14.071,58.465,1,63.817,1,70.424S14.071,82.383,29.073,82.383ZM29.6,71.7c-1.679-.478-6.816-.882-6.816-3.588,0-1.509,1.881-2.854,5.379-3.152V63.78h1.8V64.9a25.425,25.425,0,0,1,4.4.478L33.7,67.2a18.854,18.854,0,0,0-3.97-.526l-.4.005c-2.706.106-2.92,1.525-1.056,2.121,3.071.9,7.114,1.552,7.114,3.933,0,1.9-2.437,2.913-5.429,3.168v1.169h-1.8V75.962a19.041,19.041,0,0,1-5.4-.808l.825-1.823a20.654,20.654,0,0,0,4.649.67l1.168-.074C31.465,73.645,31.886,72.332,29.6,71.7ZM52.07,117.047c-5.16,3.136-13.7,5.2-23,5.2-15,0-28.073-5.352-28.073-11.959v-3.465c6.434,4.879,17.456,7.452,28.073,7.452A60.337,60.337,0,0,0,49,111.025,40.992,40.992,0,0,0,52.07,117.047ZM1,97v-3.46c6.434,4.874,17.456,7.446,28.073,7.446a62.575,62.575,0,0,0,17-2.312,40.121,40.121,0,0,0,1.224,7.282,53.714,53.714,0,0,1-18.225,3C14.071,108.958,1,103.605,1,97ZM1,83.711V80.246C7.434,85.125,18.456,87.7,29.073,87.7A61.818,61.818,0,0,0,47.41,84.992,40.044,40.044,0,0,0,46.057,93.1,55.088,55.088,0,0,1,29.073,95.67C14.071,95.67,1,90.318,1,83.711ZM62.76,25.246V21.781c6.434,4.879,17.456,7.452,28.073,7.452s21.639-2.572,28.073-7.452v3.465c0,6.607-13.065,11.959-28.073,11.959S62.76,31.853,62.76,25.246Zm0,26.575V48.356c4,3.035,9.792,5.177,16.148,6.362A45.978,45.978,0,0,0,68.42,58.88c-3.492-1.982-5.66-4.406-5.66-7.058Zm0-13.288v-3.46c6.434,4.874,17.456,7.446,28.073,7.446s21.639-2.572,28.073-7.446v3.46c0,6.607-13.065,11.959-28.073,11.959S62.76,45.14,62.76,38.534Z"
              transform="translate(-1)"
              fill="url(#linear-gradient)"
            ></path>
          </svg>
          <a :href="billing" target="_blank" style="color:black">
            <button class="card-btn mr-1" style="float:right">View App</button>
          </a>
          <div class="pt-3">
            <h3 class="text-bold service-title">Payroll Service</h3>
            <h5
              class="text-opacity"
            >Quickly Make Payments to your Employees using the Payroll Service. Automate your Transfers and allow the sytem manage it for you.</h5>
          </div>
        </a-card>
      </a-col>
      <a-col :span="8" class="mobile-full-width pr-3">
        <a-card>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="38.749"
            height="35.56"
            viewBox="0 0 128.749 127.56"
          >
            <defs>
              <linearGradient
                id="linear-gradient"
                x1="0.5"
                x2="0.5"
                y2="1"
                gradientUnits="objectBoundingBox"
              >
                <stop offset="0" stop-color="#3625be"></stop>
                <stop offset="1" stop-color="#1b135f"></stop>
              </linearGradient>
            </defs>
            <path
              id="iconmonstr-time-19"
              d="M85.35,70.9,99.491,49.5l-2.436-2.158-19.7,16.471A10.759,10.759,0,0,0,67.191,67.1a10.56,10.56,0,0,0,.853,15.01,10.8,10.8,0,0,0,15.149-.845A10.5,10.5,0,0,0,85.35,70.9ZM64.375,14.319V0H85.833V14.319A60.514,60.514,0,0,0,64.375,14.319Zm47.482,10.97,7.548-7.478,7.585,7.515L119.9,32.347A64.468,64.468,0,0,0,111.856,25.289ZM10.729,47.835H53.645v10.63H10.729ZM0,69.1H42.916v10.63H0Zm16.094,21.26H53.645v10.63H16.094ZM128.749,74.41c0,29.355-24.017,53.15-53.645,53.15a53.519,53.519,0,0,1-38.147-15.945h17.6a42.52,42.52,0,1,0,0-74.41h-17.6A53.519,53.519,0,0,1,75.1,21.26C104.732,21.26,128.749,45.055,128.749,74.41Z"
              fill="url(#linear-gradient)"
            ></path>
          </svg>
          <a :href="timetracking" style="color:black">
            <button class="card-btn mr-1" style="float:right">View App</button>
          </a>
          <div class="pt-3">
            <h3 class="text-bold service-title">Time Tracking</h3>
            <h5
              class="text-opacity"
            >Quickly Log Time, Manage Employees, Track Employees Time Log, Reports and also keep track of expenses leveraged on Projects.</h5>
          </div>
        </a-card>
      </a-col>
      <a-col :span="8" class="pr-3 mobile-full-width">
        <a-card>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18.749"
            height="15.56"
            viewBox="0 0 128.75 127.56"
          >
            <ellipse
              id="Ellipse_1"
              data-name="Ellipse 1"
              cx="64.375"
              cy="63.78"
              rx="64.375"
              ry="63.78"
              fill="#f7f7f7"
            ></ellipse>
          </svg>

          <button
            class="card-btn mr-1"
            style="float:right; background:#F7F7F7; height:20px; width:50px"
          ></button>
          <div class="pt-3">
            <h3 class="text-bold service-title">Coming Soon</h3>
            <h5
              class="text-opacity"
            >We are constantly working to build projects that makes project management a no brainer. Stay close know what we are cooking next</h5>
            <div style="height:20px; background:#F7F7F7; width:70%"></div>
          </div>
        </a-card>
      </a-col>
    </a-row>

    <!--reports -->
    <div v-show="isAdmin">
      <a-row class="pl-3 pr-3 mt-1" style="margin-top:60px">
        <a-col class="mobile-full-width" :span="15">
          <h4 class="text-bold">Quick Links</h4>
          <small class="text-opacity">Metrics of registered users, permissions and roles</small>
        </a-col>
      </a-row>

      <a-row class="pl-3 pr-3 mt-1">
        <a-col :span="8">
          <router-link :to="{name: 'users'}">
            <a-card class="mr-2">
              <a-row class="no-margin-top">
                <a-col :span="6">
                  <button class="actions--btn">
                    <a-icon type="team"/>
                  </button>
                </a-col>
                <a-col :span="12">
                  <span class="text-bold" style="font-size:17px">Users</span>
                  <br>
                  <span class="text-opacity" style="font-size:11px">Manage, Create, Edit New User</span>
                </a-col>
                <a-col :span="4">
                  <div class="trans-number">
                    <h2>{{total.users}}</h2>
                    <h4>{{total.users}}</h4>
                  </div>
                </a-col>
              </a-row>
            </a-card>
          </router-link>
        </a-col>
        <a-col :span="8">
          <router-link :to="{name: 'permissions'}">
            <a-card class="mr-2">
              <a-row class="no-margin-top">
                <a-col :span="6">
                  <button class="actions--btn">
                    <a-icon type="unlock"/>
                  </button>
                </a-col>
                <a-col :span="12">
                  <span class="text-bold" style="font-size:17px">Permissions</span>
                  <br>
                  <span
                    class="text-opacity"
                    style="font-size:11px"
                  >Manage, Create, Edit New Permissions</span>
                </a-col>
                <a-col :span="4">
                  <div class="trans-number">
                    <h2>{{total.permissions}}</h2>
                    <h4>{{total.permissions}}</h4>
                  </div>
                </a-col>
              </a-row>
            </a-card>
          </router-link>
        </a-col>
        <a-col :span="8">
          <router-link :to="{name: 'roles'}">
            <a-card class="mr-2">
              <a-row class="no-margin-top">
                <a-col :span="6">
                  <button class="actions--btn">
                    <a-icon type="share-alt"/>
                  </button>
                </a-col>
                <a-col :span="12">
                  <span class="text-bold" style="font-size:17px">Roles</span>
                  <br>
                  <span class="text-opacity" style="font-size:11px">Manage, Create, Edit New Roles</span>
                </a-col>
                <a-col :span="4">
                  <div class="trans-number">
                    <h2>{{total.roles}}</h2>
                    <h4>{{total.roles}}</h4>
                  </div>
                </a-col>
              </a-row>
            </a-card>
          </router-link>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<style lang="scss" scoped>
$primary-color: #2d1cbc;
div {
  .ant-row {
    margin-top: 30px;
  }
}
.timegraph--details {
  ul {
    list-style-type: none;
    padding-left: 0px;
    li {
      padding-top: 10px;
      h3 {
        font-size: 13px;
      }
    }
  }
}
h2 {
  .text-bold {
    font-family: "graphikMedium";
  }
}
.service-title {
  cursor: pointer;
  &:hover {
    color: $primary-color;
    &::after {
      content: "🔗";
      padding-left: 5px;
    }
  }
}
.card-btn {
  background: #f7f7f7;
  font-size: 12px;
  border: 0px;
  border-radius: 5px;
}
ul.card-links {
  list-style-type: none;
  li {
    font-size: 12px;
    padding-bottom: 10px;

    &::before {
      content: "";
      width: 200px;
      height: 20px;
      background: red;
    }
  }
}
</style>

<script>
import isAdmin from "@/mixins/isAdmin";
import moment from "moment";
export default {
  name: "home",
  // components: { Charts },
  data() {
    return {
      total: {
        users: 0,
        permissions: 0,
        roles: 0
      }
    };
  },
  mixins: [isAdmin],
  computed: {
    billing() {
      return this.$billingUrl + "?token=" + this.$auth.token();
    },
    timetracking() {
      return this.$timeTracking + "?token=" + this.$auth.token();
    }
  },
  mounted() {
    this.$store.dispatch("getUsersTotal").then(s => {
      this.total.users = s;
    });
    this.$store.dispatch("getPermissionsTotal").then(s => {
      this.total.permissions = s;
    });
    this.$store.dispatch("getRolesTotal").then(s => {
      this.total.roles = s;
    });
  },
  methods: {
    getTimeCategory() {
      let time = moment();
      let timeCategory = "";
      const timeFormat = "HH:mm:ss";

      if (
        time.isBetween(
          moment("00:00:00", timeFormat),
          moment("04:59:59", timeFormat)
        ) ||
        time.isSame(moment("00:00:00", timeFormat)) ||
        time.isSame(moment("04:59:59", timeFormat))
      ) {
        timeCategory = "Dawn ";
      } else if (
        time.isBetween(
          moment("05:00:00", timeFormat),
          moment("11:59:59", timeFormat)
        ) ||
        time.isSame(moment("05:00:00", timeFormat)) ||
        time.isSame(moment("11:59:59", timeFormat))
      ) {
        timeCategory = "Morning 🌛";
      } else if (
        time.isBetween(
          moment("12:00:00", timeFormat),
          moment("16:59:59", timeFormat)
        ) ||
        time.isSame(moment("12:00:00", timeFormat)) ||
        time.isSame(moment("16:59:59", timeFormat))
      ) {
        timeCategory = "Afternoon 🌔";
      } else if (
        time.isBetween(
          moment("17:00:00", timeFormat),
          moment("23:59:59", timeFormat)
        ) ||
        time.isSame(moment("17:00:00", timeFormat)) ||
        time.isSame(moment("23:59:59", timeFormat))
      ) {
        timeCategory = "Night 🌙🌌?";
      }

      return timeCategory;
    }
  }
};
</script>
